import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import DiagnosticToolSendShareableLinkResource from '@/modules/typeform/resources/DiagnosticToolSendShareableLinkResource';

class DiagnosticToolSendShareableLinkService extends BaseService {
  resource: typeof DiagnosticToolSendShareableLinkResource;

  constructor() {
    super();

    this.resource = DiagnosticToolSendShareableLinkResource;
  }

  send(formId: string, email: string): Promise<void> {
    return this.resource.send(formId, email);
  }
}

export default new DiagnosticToolSendShareableLinkService();
